import React from "react"

import styles from "./largeQuote.module.scss"

const LargeQuote = ({ quote, author, centeredText }) => (
  <div className={styles.wrapper} data-align={!!centeredText}>
    <div className="grid">
      <div className="gridItem xlarge-10 xlarge-offset-1">
        <blockquote className={styles.quote}>{quote}</blockquote>
        <p className={styles.author}> - {author}</p>
      </div>
    </div>
  </div>
)

export default LargeQuote
